import { BusinessError, EntityKind, ErrorKind } from '../errors';
import { AccountManagementPublicSettingsSchema, isResultSuccess } from '../types';
/**
 * AccountManagement service
 */
class AccountManagementService {
    accountManagementAdapter;
    sessionService;
    constructor({ accountManagementAdapter, sessionService }) {
        this.accountManagementAdapter = accountManagementAdapter;
        this.sessionService = sessionService;
    }
    /**
     * Fetch provider (OIDC / FranceConnect) infos
     */
    async fetchProviderInfos(providerId) {
        const result = await this.accountManagementAdapter.getAccountManagementPublicSettings();
        if (isResultSuccess(result)) {
            const publicSettings = AccountManagementPublicSettingsSchema.parse(result.response);
            const oidcProvider = publicSettings.oidcProviders?.find((provider) => provider.providerId === providerId);
            if (oidcProvider)
                return { response: oidcProvider };
        }
        return {
            error: new BusinessError(ErrorKind.NOT_FOUND, {
                entity: EntityKind.OIDC_PROVIDER,
            }),
        };
    }
    /**
     * Returns current user infos
     */
    async getCurrentUserInfos() {
        const currentUser = await this.sessionService.getCurrentUser();
        const user = {
            self: currentUser.self,
            displayName: currentUser.displayName,
            email: currentUser.email,
            franceConnect: currentUser.franceConnect,
            dateTimeLastLogin: currentUser.dateTimeLastLogin,
        };
        // franceConnect case is excluded
        if (!currentUser.franceConnect && currentUser.providerId) {
            const result = await this.fetchProviderInfos(currentUser.providerId);
            if (isResultSuccess(result)) {
                user.providerInfos = result.response;
            }
        }
        return { response: user };
    }
}
export { AccountManagementService };
//# sourceMappingURL=account-management-service.js.map